const Single = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Vehicles/Single')
const Search = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Vehicles/Search')

export default [
  {
    path: 'vehicles/create',
    name: 'VehiclesCreate',
    component: Single,
    meta: {
      title: 'Adicionar Veículo',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'vehicles',
        action: 'create'
      }
    }
  },
  {
    path: 'vehicles/:id',
    name: 'VehiclesEdit',
    component: Single,
    meta: {
      title: 'Editar Veículo',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'vehicles',
        action: 'read'
      }
    }
  },
  {
    path: 'vehicles',
    name: 'VehiclesSearch',
    component: Search,
    meta: {
      title: 'Veículos',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'vehicles',
        action: 'read'
      }
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/dashboard/vehicles.js